export default __webpack_public_path__ + "02e75e392ab5d5a8ed5ab4f8fcae9c77.png";